import { baseApi } from '@/shared/api/baseApi.js';

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      { success: true; data: { notifications: any[]; nextCursor: string | null; hasMore: boolean } },
      { cursor?: string; limit?: number; category?: string }
    >({
      query: (params = {}) => {
        const sp = new URLSearchParams();
        if (params.cursor) sp.set('cursor', params.cursor);
        if (params.limit) sp.set('limit', params.limit.toString());
        if (params.category) sp.set('category', params.category);
        return `/notifications?${sp}`;
      },
      providesTags: ['Notifications'],
    }),

    getUnreadCount: builder.query<{ success: true; data: { count: number } }, void>({
      query: () => '/notifications/unread-count',
      providesTags: ['Notifications'],
    }),

    markNotificationAsRead: builder.mutation<void, string>({
      query: (id) => ({ url: `/notifications/${id}/read`, method: 'POST' }),
      invalidatesTags: ['Notifications'],
    }),

    markAllNotificationsRead: builder.mutation<void, string | void>({
      query: (category) => ({
        url: `/notifications/read-all${category ? `?category=${category}` : ''}`,
        method: 'POST',
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsReadMutation,
} = notificationsApi;
